export default {
  documents: [],
  documentsCount: 0
}
